import { html, unsafeCSS } from 'lit';
import { LuxenElement } from '../../shared/luxen-element.js';
import { LocalizeController } from '../../shared/localize.js';
import hostStyles from '../../shared/styles/host.styles.js';
import rawStyles from './spinner.css?inline';

const styles = unsafeCSS(rawStyles);

/**
 * @summary A spinner component for indicating loading state.
 * @customElement l-spinner
 *
 * @csspart base - The SVG container element.
 *
 * @cssproperty --size - The size of the spinner (width and height). Defaults to `1em`.
 * @cssproperty --indicator-color - The color of the spinner.
 * @cssproperty --speed - The duration of one full spin cycle.
 */
export class Spinner extends LuxenElement {
  static override styles = [hostStyles, styles];

  private _localize = new LocalizeController(this);

  override render() {
    return html`
      <svg
        part="base"
        role="progressbar"
        aria-label=${this._localize.term('loading')}
        viewBox="0 0 24 24"
      >
        <path
          d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z"
          opacity=".25"
        />
        <path
          d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"
          class="spinner"
        />
      </svg>
    `;
  }
}
